export const getSession = () => {
    try {
        const user = JSON.parse(localStorage.getItem('AutoParts') || 'null');
        if (typeof user?.username !== 'string' || !user.username.trim() || ![1, 2].includes(Number(user.role))) return null;
        return { username: user.username, role: Number(user.role), shop: user.shop };
    } catch {
        return null;
    }
};
